import { UserType as ApiUserType } from 'src/api/generated/auth/types';
import { UserMeType } from './types';

export const mapUserMeType = (user: ApiUserType): UserMeType => {
  return {
    id: user.id,
    firstname: user.firstname,
    lastname: user.lastname,
    email: user.email ?? null,
  };
};
